import { Navigate, useLocation } from "react-router-dom";
import { LoaderCircle } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children, onboarding = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="route-loading" data-testid="auth-loading-screen"><LoaderCircle className="spin" size={28}/><span>Checking your account…</span></div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }}/>
  if (!onboarding && !user.onboarding_completed) return <Navigate to="/onboarding" replace/>;
  if (onboarding && user.onboarding_completed) return <Navigate to="/app" replace/>;
  return children;
}
